// We will use this simple function to decryp decorative hashes that come from the backend
// (they are just for visual effects with no risk)
export function shallowDecipher(slug: string) {
  const id = slug.split("-").pop();
  if (!id) throw new Error("Invalid slug");
  const _id = Number(id.slice(4, id.length - 2));

  return _id;
}
